import React from 'react';
import * as $ from 'jquery';

import { generalConstants } from '../constants';

import '../assets/plugin/fileuploader-1.3/src/jquery.fileuploader.js';
import '../assets/plugin/fileuploader-1.3/src/jquery.fileuploader.css';
import '../assets/css/jquery.fileuploader-theme-thumbnails.css';

class GalleryFileuploader extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
  }

  componentDidMount() {
    console.log('AntikodeUploaderReadyToServ....');
    const addHandler = this.props.addHandler;
    const selectHandler = this.props.selectHandler;
    const shortHandler = this.props.shortHandler;

    $('.antikode-uploader').fileuploader({
      extensions: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
      changeInput: ' ',
      theme: 'thumbnails',
      enableApi: true,
      addMore: true,
      fileMaxSize: 2,
      thumbnails: {
        box:
          '<div class="fileuploader-items">' +
          '<ul class="fileuploader-items-list">' +
          '<li class="fileuploader-thumbnails-input"><div class="fileuploader-thumbnails-input-inner">+</div></li>' +
          '</ul>' +
          '</div>',
        item:
          '<li class="fileuploader-item">' +
          '<div class="fileuploader-item-inner">' +
          '<div class="thumbnail-holder">${image}</div>' +
          '<div class="actions-holder">' +
          '<a class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fa fa-trash" aria-hidden="true"></i></a>' +
          '</div>' +
          '<div class="progress-holder">${progressBar}</div>' +
          '</div>' +
          '</li>',
        item2:
          '<li class="fileuploader-item">' +
          '<div class="fileuploader-item-inner">' +
          '<div class="thumbnail-holder">${image}</div>' +
          '<div class="actions-holder">' +
          '<a class="fileuploader-action fileuploader-action-sort" title="${captions.sort}"><i class="fa fa-arrows" aria-hidden="true"></i></a>' +
          '<a class="fileuploader-action fileuploader-action-edit" title="Info"><i class="fa fa-cog" aria-hidden="true"></i></a>' +
          '<a class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fa fa-trash" aria-hidden="true"></i></a>' +
          '</div>' +
          '</div>' +
          '</li>',
        startImageRenderer: false,
        canvasImage: false,
        _selectors: {
          list: '.fileuploader-items-list',
          item: '.fileuploader-item',
          start: '.fileuploader-action-start',
          retry: '.fileuploader-action-retry',
          remove: '.fileuploader-action-remove',
          sorter: '.fileuploader-action-sort'
        },
        onItemShow: function(item, listEl, inputEl) {
          if (selectHandler) {
            selectHandler(item, listEl, inputEl);
          }
          var plusInput = listEl.find('.fileuploader-thumbnails-input');

          plusInput.insertAfter(item.html);

          if (item.format == 'image') {
            item.html.find('.fileuploader-item-icon').hide();
          }
        }
      },
      afterRender: function(listEl, parentEl, newInputEl, inputEl) {
        var plusInput = listEl.find('.fileuploader-thumbnails-input'),
          api = $.fileuploader.getInstance(inputEl.get(0));

        plusInput.on('click', function() {
          if (addHandler) {
            addHandler();
          } else {
            api.open();
          }
        });
      },
      upload: {
        url: generalConstants.BASE_URL + 'api/fileupload/uploads/',
        headers: { 'x-api-key': generalConstants.API_KEY },
        data: null,
        type: 'POST',
        enctype: 'multipart/form-data',
        start: true,
        synchron: true,
        beforeSend: null,
        onSuccess: function(data, item) {
          setTimeout(function() {
            item.html
              .find('.fileuploader-action-remove')
              .before(
                '<a class="fileuploader-action fileuploader-action-edit" title="Info"><i class="fa fa-cog" aria-hidden="true"></i></a>'
              );
            item.html
              .find('.fileuploader-action-edit')
              .before(
                '<a class="fileuploader-action fileuploader-action-sort" title="Sort"><i class="fa fa-arrows" aria-hidden="true"></i></a>'
              );
            item.html.find('.progress-holder').hide();
            item.renderThumbnail();
            console.log(item);
          }, 400);
        },
        onError: function(item) {
          item.html.find('.progress-holder').hide();
          item.html.find('.fileuploader-item-icon i').text('Failed!');
        },
        onProgress: function(data, item) {
          var progressBar = item.html.find('.progress-holder');

          if (progressBar.length > 0) {
            progressBar.show();
            progressBar.find('.fileuploader-progressbar .bar').width(data.percentage + '%');
          }
        }
      },
      dragDrop: {
        container: '.fileuploader-thumbnails-input'
      },
      onRemove: function(item) {
        console.log('Remove File :' + item.name);
      },
      sorter: {
        selectorExclude: null,
        placeholder:
          '<li class="fileuploader-item fileuploader-sorter-placeholder"><div class="fileuploader-item-inner"></div></li>',
        scrollContainer: window,
        onSort: function(list, listEl, parentEl, newInputEl, inputEl) {
          var api = $.fileuploader.getInstance(inputEl.get(0)),
            fileList = api.getFileList();
        }
      }
    });
  }

  render() {
    return (
      <div>
        <input
          type="file"
          ref="fileUploader"
          name="files"
          className="antikode-uploader"
          id={this.props.id}
        />
      </div>
    );
  }
}

export { GalleryFileuploader };


// WEBPACK FOOTER //
// ./src/components/GalleryFileUploader.js